import { IHasChildren } from '@/lib/interface';
import { TBreadcrumbProps } from '@/types';
import { LucideIcon } from 'lucide-react';
import LayoutPage from '../layoutPage';
import { ReactNode } from 'react';

type TProps = IHasChildren & {
  breadcrumb?: TBreadcrumbProps;
  icon?: LucideIcon;
  header?: {
    title?: ReactNode;
    description?: ReactNode;
  }
};

const LayoutVerifications = ({ children, header, breadcrumb, icon }: TProps) => (
  <LayoutPage
    icon={icon}
    header={header}
    breadcrumb={breadcrumb}>
    <div className='pt-3 md:pt-5 flex flex-col space-y-3'>
      {children}
    </div>
  </LayoutPage>
);

export default LayoutVerifications;
